import { useCallback, useEffect, useState } from 'react'

import { EXPERIMENTS } from '@src/experiments'
import GatsbyPageContext from '@src/quince-site-common/src/domains/GatsbyPageContext'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import useExperimentBucket from '@src/quince-site-common/src/hooks/useExperimentBucket'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import { getFromLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/getFromLocalStorageWithExpiry'
import { setInLocalStorageWithExpiry } from '@src/quince-site-common/src/utils/setInLocalStorageWithExpiry'

const EXPIRY_TIME_IN_MINS = 60
export const resetCheckoutPopup = () => {
  setInLocalStorageWithExpiry(ANALYTIC_COOKIES.CHECKOUT_POPUP, 'closed', EXPIRY_TIME_IN_MINS)
}

export const useGetIsCheckoutPopupVisible = (pageContext: GatsbyPageContext) => {
  const [showCheckoutPopup, setShowCheckoutPopup] = useState(false)
  const deviceInfo = useDeviceInfo()

  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE

  const isMobilePDP = isMobile && pageContext && pageContext.pageType === 'PDP'
  const isCartPage = pageContext && pageContext.pageType === 'CART'
  const isCartPopupClosedInOneHour = getFromLocalStorageWithExpiry(ANALYTIC_COOKIES.CHECKOUT_POPUP, false) == 'closed'

  const isCardPopupShowBucket = useExperimentBucket(EXPERIMENTS.CHECKOUT_CARD_POPUP.experimentName) == 'show'

  useEffect(() => {
    const shouldShow = !isCartPage && !isMobilePDP && !isCartPopupClosedInOneHour && isCardPopupShowBucket
    setShowCheckoutPopup(shouldShow)
  }, [isCardPopupShowBucket, isMobilePDP, isCartPage, isCartPopupClosedInOneHour])

  const closeCheckoutPopup = useCallback(() => {
    setInLocalStorageWithExpiry(ANALYTIC_COOKIES.CHECKOUT_POPUP, 'closed', EXPIRY_TIME_IN_MINS)
    setShowCheckoutPopup(false)
  }, [setShowCheckoutPopup, setInLocalStorageWithExpiry, showCheckoutPopup])

  return { showCheckoutPopup, closeCheckoutPopup }
}
